import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from "./store/store";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {Template} from "./component/template/Template";
import FlagComponent from "./component/flag/flag";
import HomeComponent, {loader as gameLoader} from "./component/home/home";
import WinComponent from "./component/flag/win/win";
import LooseComponent from "./component/flag/loose/loose";
import ErrorComponent from "./component/error/error";
import LeaderboardComponent, {loader as leaderboardLoader} from "./component/leaderboard/leaderboard";
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        element: <Template />,
        children: [
            {
                path: "",
                element: <HomeComponent/>,
            },
            {
                path: "/leaderboard",
                element: <LeaderboardComponent/>,
                loader: leaderboardLoader
            },
            {
                path: "/game",
                element: <FlagComponent/>,
                loader: gameLoader
            },
            {
                path: "/win",
                element: <WinComponent/>
            },
            {
                path: "/loose",
                element: <LooseComponent/>
            },
            {
                path: "/error",
                element: <ErrorComponent/>
            }
        ]
    }
]);

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </GoogleOAuthProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
